import { inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Auth Services
import { AuthenticationService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if(!this.authenticationService.isTokenExpired()){
            const status = this.authenticationService.fetch2FAStatus(); //Value setting from router.service.ts
            if(status === "0"){ //Not setup at all so show enable screen
                this.router.navigate(['/auth/two-factor-enable/'], { queryParams: { returnUrl: state.url } });
            }else if(status === "1"){ //Normal checkup
                this.router.navigate(['/auth/two-factor'], { queryParams: { returnUrl: state.url } });
            }
            else if(status === "2"){ //Setup Password checkup
                this.router.navigate(['/auth/setup-password'], { queryParams: { returnUrl: state.url } });
            }

            return true;
        }
        
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
